
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { useEvaluationUsage } from "@/hooks/useEvaluationUsage";
import { CreateJobDialog } from "./CreateJobDialog";
import { EvaluationLimitDialog } from "@/components/dialogs/EvaluationLimitDialog";
import { useState } from "react";

interface TestActionsProps {
  jobId: string;
  jobDetails?: {
    title?: string;
    description?: string;
    key_responsibilities?: string;
    years_of_experience?: number;
    key_skills?: string[];
    creator?: {
      id: string;
    } | null;
  };
}

export const TestActions = ({ jobId, jobDetails }: TestActionsProps) => {
  const { user } = useAuth();
  const { usage: evaluationUsage } = useEvaluationUsage();
  const [showCreateDialog, setShowCreateDialog] = useState(false);
  const [showEvaluationLimitDialog, setShowEvaluationLimitDialog] = useState(false);
  
  // Only show actions if user is logged in and is the employer who created the job
  const isEmployer = user?.id === jobDetails?.creator?.id;

  if (!isEmployer) return null;

  const canCreateEvaluations = evaluationUsage?.can_create_tests ?? true;

  const handleClick = () => {
    if (!canCreateEvaluations) {
      setShowEvaluationLimitDialog(true);
    } else {
      setShowCreateDialog(true);
    }
  };

  return (
    <div className="flex gap-2">
      <Button 
        variant="outline" 
        onClick={handleClick}
        disabled={!canCreateEvaluations}
      >
        <Plus className="h-4 w-4 mr-2" />
        Create New Test
      </Button>

      <CreateJobDialog
        open={showCreateDialog}
        onOpenChange={setShowCreateDialog}
      />

      <EvaluationLimitDialog
        open={showEvaluationLimitDialog}
        onOpenChange={setShowEvaluationLimitDialog}
      />
    </div>
  );
};
